import React from 'react'

import { PriceTableItemMembership } from '../../../typings/PriceTable'

import FullPriceMembershipSummaryItem from './FullPriceMembershipSummaryItem'
import PartialPriceMembershipSummaryItem from './PartialPriceMembershipSummaryItem'

interface Props {
  membership: PriceTableItemMembership
}

const MembershipPriceSummaryItem: React.FC<React.PropsWithChildren<Props>> = ({ membership }) => {
  if (membership.partialPriceTimeRange) {
    return <PartialPriceMembershipSummaryItem membership={membership} />
  }

  return <FullPriceMembershipSummaryItem membership={membership} />
}

export default MembershipPriceSummaryItem
